/**
 * Fiskal Cloud Statistics API
 * # Overview  Statistics API is used for  * read statistics about FC data (tenants, business premises, organizations, ERSes, TSS, ...) or transactions  ## Getting an authentication token  To be able to work with the API you need to get an authentication token to use with all subsequent API calls described below. Get the token via the [Oauth endpoint](https://fiskal.cloud/auth/realms/df/protocol/openid-connect/token) of the Fiskal Cloud. Use client_id=df-api and grant_type=password for requesting a token. > The access token grants same access rights as the user has in the Fiskal Cloud Portal.  Example request to get token via curl: ``` curl -X POST \\ https://fiskal.cloud/auth/realms/df/protocol/openid-connect/token \\ -H \'Accept: application/json\' \\ -H \'Content-Type: application/x-www-form-urlencoded\' \\ -d \'username=<USER_EMAILADDRESS>&password=<USER_PASSWORD>&client_id=df-api&grant_type=password\' ``` Save the access_token entry of the response and pass it as bearer token in all subsequent API calls. Pass it as header parameter. ```\'Authorization: Bearer <ACCESS_TOKEN_FROM_AUTHENTICATION>\'```  For details on access tokens, please check general Oauth documentation like [Oauth.com](https://www.oauth.com/oauth2-servers/access-tokens/access-token-response/)  ## Tenant context All methods of this API work in the context of the logged in user\'s tenant account. For creating new elements you need to set the tenant id in the request. You can retrieve your tenant id by using the /tenants/tenant endpoint. It is fixed, so it can safely stored for later use.  ## Managed Tenant You can use a different tenant for operations if you have a permission to managed them. You can select managed tenant by sending `X-Managed-Tenant` header with `tenantId` of the managed tenant. All operations (creating, updating and getting) are done in the context of the managed tenant with this header.  ``` curl -X GET \\ -i \'https://fiskal.cloud/api/statistics/tenant-statistics\' \\ -H \'Authorization: Bearer {{AccessToken}}\' \\ -H \'X-Managed-Tenant: {{managedTenantId}}\' ```  # Changelog ## 0.4.0 * Add Swissbit 
 *
 * The version of the OpenAPI document: 0.4.0
 * Contact: info@deutsche-fiskal.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Number of TSS per status
 */
export interface TssStatusStatisticsDTO { 
    /**
     * Number of active TSS
     */
    active?: number;
    /**
     * Number of disabled TSS
     */
    disabled?: number;
    /**
     * Number of suspended TSS
     */
    suspended?: number;
    /**
     * Number of inactive TSS
     */
    inactive?: number;
}

export class ClsTssStatusStatisticsDTO { 
    /**
     * Number of active TSS
     */
    active?: number = undefined;
    /**
     * Number of disabled TSS
     */
    disabled?: number = undefined;
    /**
     * Number of suspended TSS
     */
    suspended?: number = undefined;
    /**
     * Number of inactive TSS
     */
    inactive?: number = undefined;
}

